import { PaymentMethodCodes } from '@constants/payment-method.codes';

import ZelleIcon from '../assets/img/method-zelle-icon.png';
import MobilePaymentIcon from '../assets/img/method-pm-icon.png';
import CasheaIcon from '../assets/img/method-cashea-icon.png';
import CCIcon from '../assets/img/method-cc-icon.png';

export const mapPaymentMethodIcon = (method?: string): string => {
    if (!method) return '';

    switch (method) {
        case PaymentMethodCodes.MOBILE_PAYMENT:
            return MobilePaymentIcon;
        case PaymentMethodCodes.ZELLE:
            return ZelleIcon;
        case PaymentMethodCodes.CASHEA:
            return CasheaIcon;
        case PaymentMethodCodes.CC:
        default:
            return CCIcon;
    }
};
